import {ARK} from './ark.js'

/** display **/
let styleNode = null;
/**
 * 生成css内容
 * @param className
 * @param styleObj
 * @returns {string}
 */
function makeCss(className, styleObj) {
  let cssText = '';
  let sonCss = '';
  let bodyCss = '';
  if (!className || !styleObj) {
    return cssText;
  }
  cssText += className + '{';
  for (let key in styleObj) {
    if (styleObj.hasOwnProperty(key)) {
      const value = styleObj[key];
      if (typeof value === 'object') {
        if (key.indexOf('&') === 0) {
          key = key.slice(1);
          sonCss += makeCss(className + key, value);
        } else {
          sonCss += makeCss(className + ' ' + key, value);
        }
      } else {
        bodyCss += key + ':' + styleObj[key] + ';';
      }
    }
  }
  if (bodyCss) {
    cssText += bodyCss + '}\n' + sonCss;
  } else {
    cssText = sonCss;
  }
  return cssText;
}

/**
 * 增加style－node元素
 * @param cssNode
 */
function appendCss(cssNode) {
  if (!styleNode) {
    const body = document.querySelector('body');
    styleNode = document.createElement('style');
    styleNode.type = 'text/css';
    body.insertBefore(styleNode, body.childNodes[0]);
  }
  styleNode.appendChild(cssNode);
}
/**
 * 创建一个Txt Node
 * @param cssText
 * @returns {Text}
 */
function createCss(cssText) {
  return document.createTextNode(cssText);
}
/**
 * 移除Txt Node
 * @param cssNode
 */
function removeCss(cssNode) {
  if (styleNode && cssNode) {
    styleNode.removeChild(cssNode);
  }
}

export class SilverArkDisplay extends ARK.base {
  constructor(opt) {
    opt = opt || {};
    super(opt)
    const data = this.data
    this.__target__ = data.target || document.body;
    this.__class_name__ = data.className ? data.className : (this.getName() + '-' + this.getId());
    this.__css_node__ = null;
    this.__style__ = this.makeStyle(data) || data.style || {};
    this.__data__ = data.data || {};
    this.__node__ = this.initView(this.__style__, this.__data__);
    this._makeCss();
    this._renderView(this.__node__, this.__style__, this.__data__);
    this._append();
  }

  /**
   * 创建CSS
   * @private
   */
  _makeCss() {
    if (this.__class_name__) {
      this.__node__.classList.add(this.__class_name__);
      const cssText = makeCss('.' + this.__class_name__, this.__style__);
      this.removeCss();
      this.__css_node__ = createCss(cssText);
      appendCss(this.__css_node__);
    }
  }


  /**
   * 加入视图
   * @private
   */
  _append() {
    this.__target__.appendChild(this.__node__);
  }

  /**
   * 销毁所有
   */
  destroy() {
    super.destroy();
    this.removeCss();
    this.__data__ = null;
    this.__style__ = null;
    this.__css_node__ = null;
    this.__target__.removeChild(this.__node__);
    this.__node__ = null;
  }

  /**
   * 初始化视图
   * @param style
   * @param data
   * @returns {Element}
   */
  initView(style, data) {
    return document.createElement('div');
  }

  /**
   * 数据更新改变视图
   * @param node
   * @param style
   * @param data
   * @returns {SilverDisplay}
   */
  renderView(node, style, data) {
    return this;
  }

  _renderView() {
    this.renderView(this.__node__, this.__style__, this.__data__);
    this.fire('renderView');
  }

  /**
   * 设置style样式
   * @param style
   * @returns {SilverDisplay}
   */
  setViewStyle(style) {
    this.__style__ = style || {};
    this._makeCss();
    this.fire('setViewStyle', this.__style__);
    return this;
  }

  /**
   * 设置数据
   * @param data
   * @returns {SilverDisplay}
   */
  setViewData(data) {
    this.__data__ = data || {};
    this._renderView();
    this.fire('setViewData', this.__data__);
    return this;
  }

  /**
   * 创建style对象
   * @param opt
   * @returns {null}
   */
  makeStyle(opt) {
    return {};
  }

  /**
   * 清除CSS
   */
  removeCss() {
    removeCss(this.__css_node__);
  }

  /**
   * 根据opt重绘样式
   *
   */
  setStyleByOption(opt) {
    this.__style__ = this.makeStyle(opt) || opt.style || {};
    this.setViewStyle(this.__style__);
    this.fire('setStyleByOption', opt);
    return this;
  }


  /**
   * 根据opt重新render组件
   *
   */
  renderByOption(opt) {
    this.setStyleByOption(opt);
    this.setViewData(opt.data);
    this.fire('renderByOption', opt);
    return this;
  }

  redraw(data) {
    this.renderByOption(data)
    return this
  }

  /**
   * 返回target对象
   */
  getTarget() {
    return this.__target__;
  }

  /**
   * 返回DOM
   */
  getDOMNode() {
    return this.__node__;
  }

  /**
   * 返回样式
   */
  getViewStyle() {
    return this.__style__;
  }

  /**
   * 返回数据
   */
  getViewData() {
    return this.__data__;
  }

  /**
   * 返回CSS-dom
   */
  getCssNode() {
    return this.__css_node__;
  }

  /**
   * 返回class名
   */
  getClassName() {
    return this.__class_name__;
  }

  /**
   * 获取组件名称
   * @return {String}
   */
  getName() {
    return 'SilverArkDisplay';
  }
}



// WEBPACK FOOTER //
// ./src/page/main/display.js